const REQUEST_URL = 'https://api.ecellbphc.in'

module.exports = {
    REQUEST_URL
}